const DATE_UNITS = {
  day: 86400,
  hour: 3600,
  minute: 60,
  second: 1
}

const getSecondsDiff = timestamp => (Date.now() - timestamp) / 1000
const getUnitAndValueDate = (secondsElapsed) => {
  for (const [unit, secondsInUnit] of Object.entries(DATE_UNITS)) {
    if (secondsElapsed >= secondsInUnit || unit === 'second') {
      const value = Math.floor(secondsElapsed / secondsInUnit) * -1
      return { value, unit }
    }
  }
}

const getDateString = (timestamp) => {
  function pad (number) {
    if (number < 10) {
      return '0' + number
    }
    return '' + number
  }
  const date = new Date(timestamp)
  const fecha = `${pad(date.getDate())}/${pad(date.getMonth() + 1)}/${date.getFullYear()}`
  const hora = `${date.getHours()}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`
  return `${hora} ${fecha}`
}

const parseDate = date => {
  const parsedDate = Date.parse(date)
  if (!isNaN(parsedDate)) return parsedDate

  const splitDate = date.split(/[^0-9]/)
  return new Date(splitDate[0], splitDate[1] - 1, splitDate[2], splitDate[3], splitDate[4], splitDate[5])
}

const getTimeAgo = date => {
  const timestamp = parseDate(date)
  if (typeof Intl?.RelativeTimeFormat === 'function') {
    const rtf = new Intl.RelativeTimeFormat()

    const secondsElapsed = getSecondsDiff(timestamp)
    const { value, unit } = getUnitAndValueDate(secondsElapsed)
    return rtf.format(value, unit)
  } else {
    return getDateString(timestamp)
  }
}

export default getTimeAgo
